export const noticeEntityId = {
  type: "string",
  minLength: 1,
  maxLength: Number.MAX_SAFE_INTEGER
};
